import $axios from "../api/accessor";
import { $api } from "../api/api";

export const BankCardsServices = {

  async getBankCards() {
    try {
      const response = await $axios.get($api("get_bank_cards"));
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async addBankCard() {
    try {
      const response = await $axios.post($api("add_bank_card"));
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async deleteBankCard(id: number) {
    try {
      const response = await $axios.delete($api("delete_bank_card", { id }));
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
